export const getPatientFlowId = state => state.patientFlows.patientFlow.id;
export const getPatientFlowData = state => state.patientFlows.patientFlow;
export const patientFlowIsFetching = state => state.patientFlows.loading;